import { configConstants } from '../constants';
import { alertActions } from 'actions';
import { configService } from 'services';
import { global } from 'config';

//using for portal pricing
export const configActions = {
  getAll,
  update,
};

function getAll(filters) {
  return dispatch => {
    dispatch(request());

    configService.getAll(filters)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: configConstants.GET_CONFIG_ALL_REQUEST } }
  function success(data) { return { type: configConstants.GET_CONFIG_ALL_SUCCESS, data } }
  function failure(error) { return { type: configConstants.GET_CONFIG_ALL_FAILURE, error } }
}

function update(updatedValues) {
  return dispatch => {
    dispatch(request(updatedValues));

    configService.update(updatedValues)
      .then(
        data => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          // history.push(gisRoutes.account.customer.list);
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error.data || error.message));
        });
  };

  function request() { return { type: configConstants.UPDATE_CONFIG_REQUEST } }
  function success() { return { type: configConstants.UPDATE_CONFIG_SUCCESS } }
  function failure(error) { return { type: configConstants.UPDATE_CONFIG_FAILURE, error } }
}
